import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

export const writeAccountingReport = ({
  t,
  id,
  searchValues,
  responseReportData,
  vPayments,
  cPayments,
}: stdObject) => {
  let balance = responseReportData.previous;
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: [
        { NAME: t("p.previousBalance"), BALCAJ: toPrice(balance) },
        ...responseReportData.list
          .sort((a: stdObject, b: stdObject) =>
            a.FECCAJ.localeCompare(b.FECCAJ),
          )
          .flatMap((e: stdObject) => {
            balance = e.RESCAJ ? e.ENTCAJ : balance + e.ENTCAJ - e.SALCAJ;
            const payList = e.AREA === "c" ? cPayments : vPayments;
            const method = payList.find(
              (v: stdObject) => v.CODTPA === e.TIPDIN,
            )?.NOMTPA;
            const base = {
              ...e,
              TIPDIN: method,
              NAME:
                e.MKEY === "DIN"
                  ? t(`c.${e.NOMCAJ}`) + ` ${e.SERDIN}-${e.CODDIN}`
                  : e.NOMCAJ +
                    (e.RESCAJ ? ` (${t("p.balanceCorrection")})` : ""),
              ENTCAJ: e.ENTCAJ === 0 ? "-" : toPrice(e.ENTCAJ),
              SALCAJ: e.SALCAJ === 0 ? "-" : toPrice(e.SALCAJ),
              BALCAJ: toPrice(balance),
              BGCOLOR: e.RESCAJ ? colors.lightYellow : null,
            };

            if (e.CARDIN === 0) {
              return [base];
            } else {
              balance -= e.CA2DIN;
              return [
                base,
                {
                  ...e,
                  TIPDIN: method,
                  NAME:
                    t(`c.${e.NOMCAJ}`) +
                    ` ${e.SERDIN}-${e.CODDIN} (${t("p.collectionFee")})`,
                  ENTCAJ: "-",
                  SALCAJ: toPrice(e.CA2DIN),
                  BALCAJ: toPrice(balance),
                  BGCOLOR: colors.lightViolet,
                },
              ];
            }
          }),
      ],
    },
  };
};
